/**
 * File events.js.
 *
 * Handles events list blocks.
 */
(function ($) {
    'use strict';
})(jQuery);